import styled from "styled-components";

const ThemeStyle = styled.div`
  /* .styled-tabs .Polaris-Tabs__Title {
    color: ${(props) => props.tabColor || "green"};
  }
  p,
  p > span,
  div > span,
  span > span {
    color: ${(props) => props.contentColor || "orange"};
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.headingColor || "blue"};
  }
  .Polaris-Frame-ToastManager .Polaris-Frame-Toast {
    background-color: ${(props) => props.toastBackground || "blue"};
    color: ${(props) => props.toastColor || "blue"};
  } */
`;

export default ThemeStyle;
